import React from 'react'

/**
 * Renders hidden images to have them loaded immediately by the browser
 * @param props
 * @constructor
 */
export const ImagePreloader = (props: { srcs: readonly string[] }) => {
  return (
    <>
      {
        props.srcs.map(src => (
          <img
            key={src}
            src={src}
            alt=""
            style={{
              position: 'fixed',
              right: '-100vw',
              bottom: '-100vh',
              width: '1px',
              height: '1px',
            }}
          />
        ))
      }
    </>
  )
}